export const PIANO_AUTH_CRED = "auth_piano";